import * as moment from "moment";
import { ActionIcon, Box, Button, Container, Flex, Text, Tooltip } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useMediaQuery } from "@mantine/hooks";
import { openConfirmModal } from "@mantine/modals";
import { IconDownload, IconPrinter, IconSquareRoundedCheck } from "@tabler/icons";
import FloatingMenu from "components/FloatingMenu";
import { PrintModal } from "components/PrintModal";
import { MantineReactTable } from "mantine-react-table";
import { hasPermission } from "pages/Auth/permissionGuard";
import { useEffect, useMemo, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";
import {
  getBodyContent,
  getCsvContent,
  getCustomId,
  getFields,
  getFilterPayload,
  getHeaders,
} from "services/filterHelperFunctions";
import { api_filter } from "services/master.service";
import { showErrorToast, showSuccessToast } from "utilities/Toast";

import { report_api } from "./report.service";
import AppBreadcrumb from "../../../components/AppBreadcrumb";

export default function SalesReport() {
  const [head, setHead] = useState([]);
  const [body, setBody] = useState([]);
  const [foot, setFoot] = useState([]);
  const [csv, setCsv] = useState([]);
  const [isCsv, setIsCsv] = useState(false);
  const [date, setDate] = useState(moment());
  let isMobileScreen = useMediaQuery("(max-width: 768px)");
  const [columnFilters, setColumnFilters] = useState([]);
  const [filename, setFilename] = useState("file");

  const openAcceptStockConfirmation = id => {
    openConfirmModal({
      size: "500px",
      centered: true,
      title: "Are you sure you want to acknowledge this ?",
      children: <Text size="sm">This cannot be undone.</Text>,
      labels: { confirm: "Acknowledge", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: async () => await acknowledge(id),
      confirmProps: { color: "green" },
      position: "center",
    });
  };

  const acknowledge = async id => {
    await report_api.acknowledge_cutoff({ id }).then(res => {
      console.log(res);
      if (res.success) {
        showSuccessToast({ title: "Success", message: res.message });
        data.refetch();
      } else {
        showErrorToast({ title: "Error", message: res.message });
      }
    });
  };

  const columns = useMemo(
    () => [
      {
        header: "Counter Name",
        accessorKey: "counter_name",
        size: "auto",
      },
      {
        header: "Cash",
        accessorKey: "cash",
        filterVariant: "range",

        Cell: ({ cell }) => <span> {cell.getValue() ? cell.getValue() : "-"} </span>,
        size: "auto",
      },
      {
        header: "Card",
        accessorKey: "card",
        filterVariant: "range",

        Cell: ({ cell }) => <span> {cell.getValue() ? cell.getValue() : "-"} </span>,
        size: "auto",
      },
       {
        header: "Upi",
        accessorKey: "upi",
        filterVariant: "range",

        Cell: ({ cell }) => <span> {cell.getValue() ? cell.getValue() : "-"} </span>,
        size: "auto",
      },
      {
        header: "Gift",
        accessorKey: "gift",
        filterVariant: "range",

        Cell: ({ cell }) => <span> {cell.getValue() ? cell.getValue() : "-"} </span>,
        size: "auto",
      },
      {
        header: "Credit",
        accessorKey: "credit",
        filterVariant: "range",

        Cell: ({ cell }) => <span> {cell.getValue() ? cell.getValue() : "-"} </span>,
        size: "auto",
      },
      {
        header: "Acknowledge By",
        accessorKey: "acknowledge_by_name",
        Cell: ({ cell }) => <span> {cell.getValue() ? cell.getValue() : "-"} </span>,
        size: "auto",
      },
      {
        header: "Acknowledged At",
        accessorKey: "acknowledged_at",
        Cell: ({ cell }) => (
          <span> {cell.getValue() ? moment(cell.getValue()).format("DD-MM-YYYY") : "-"} </span>
        ),
        size: "auto",
      },
      {
        accessorFn: originalRow => new Date(originalRow.date),
        id: "date",
        header: "Date",
        accessorKey: "date",
        size: "auto",
        Cell: ({ cell }) => cell.getValue().toLocaleDateString(),
        filterVariant: "date-range",
      },
    ],
    []
  );

  // const data = useQuery({
  //   queryKey: ["cut-off-report", date],
  //   queryFn: () => report_api.get_cutoff(moment(date).format("DD-MM-YYYY")),
  //   onSuccess: data => {
  //     console.log(data);
  //     if (!data.success) {
  //       showErrorToast({ title: "Error", message: data.message });
  //     }
  //   },
  // });

  const data = useQuery({
    queryKey: ["cut-off-report", date, columnFilters], // Include filters in query key
    queryFn: async () => {
      if (columnFilters.length > 0) {
        return printFilter(false); // Fetch filtered data when table filters are applied
      } else {
        return report_api.get_cutoff(moment(date).format("YYYY-MM-DD"));
      }
    },
    keepPreviousData: true,
    onSuccess: data => {
      console.log(data);
    },
  });
  

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    //console.log(head);
    if (body.length !== 0 && head.length !== 0) {
      if (!isCsv) {
        handlePrint();
        setBody([]);
        setHead([]);
      }
    }
    setIsCsv(false);
  }, [body, head]);

  // const get_text = html => {
  //   let div = document.createElement("div");
  //   div.innerHTML = html;
  //   let text = div.textContent || div.innerText || "";
  //   return text;
  //   //return parseFloat(text.replace(/[^0-9.]/g, ""));
  // };

  // const get_sum = removeAction => {
  //   const datatablebody = document
  //     .querySelector(".datatable-wrapper")
  //     ?.querySelector("tbody")
  //     ?.querySelectorAll("tr");
  //   let column_total = [];
  //   datatablebody?.forEach(e => {
  //     let row_total = [];
  //     const d = e?.querySelectorAll("td");
  //     d?.forEach((tag, i) => {
  //       if (!removeAction || d.length !== i + 1) {
  //         row_total.push(parseFloat(get_text(tag?.innerHTML).replace(/[^0-9.]/g, "")));
  //       }
  //     });
  //     column_total.push(row_total);
  //   });

  //   let total = [];
  //   column_total.map((e, i) => {
  //     e.map((h, index) => {
  //       if (i === 0) {
  //         total.push(h);
  //       } else {
  //         total[index] = h + total[index];
  //       }
  //     });
  //   });

  //   let nan_count = 0;
  //   total.map((e, i) => {
  //     if (isNaN(e)) {
  //       nan_count += 1;
  //     }
  //   });
  //   if (nan_count === total.length) {
  //     setFoot([]);
  //   } else {
  //     setFoot(total);
  //   }

  //   return total;
  // };

  // const print = removeAction => {
  //   var head_content = [];
  //   var body_content = [];
  //   const datatable = document
  //     .querySelector(".datatable-wrapper")
  //     ?.querySelector("thead")
  //     ?.querySelectorAll("th");
  //   datatable !== undefined &&
  //     datatable?.forEach((e, i) => {
  //       if (!removeAction || datatable.length !== i + 1) {
  //         head_content.push(e?.querySelector(".mantine-TableHeadCell-Content-Wrapper")?.innerText);
  //       }
  //     });

  //   const datatablebody = document
  //     .querySelector(".datatable-wrapper")
  //     ?.querySelector("tbody")
  //     ?.querySelectorAll("tr");
  //   datatablebody?.forEach(e => {
  //     let row = [];
  //     const d = e?.querySelectorAll("td");
  //     d?.forEach((tag, i) => {
  //       if (!removeAction || d.length !== i + 1) {
  //         row.push(get_text(tag?.innerHTML));
  //       }
  //     });
  //     body_content.push(row);
  //   });

  //   setHead(head_content);
  //   setBody(body_content);
  //   let csv_data = [];
  //   csv_data.push(head_content);
  //   body_content.map((e, i) => {
  //     csv_data.push(e);
  //   });
  //   const cols = [];
  //   let sum = [];
  //   get_sum(removeAction).map((e, i) => {
  //     if (isNaN(e) || !cols?.includes(i, 0)) {
  //       sum.push("");
  //     } else {
  //       sum.push(e);
  //     }
  //   });
  //   csv_data.push(sum);
  //   setCsv(csv_data);
  // };
  // const printFilter = () => {
  //   const model = "CutOff";

  //   const appendData = [
  //     { id: "name", append: "counter__", replace_id: "counter_name" },
  //     { id: "cash", append: "" },
  //     { id: "card", append: "" },
  //     { id: "gift", append: "" },
  //     { id: "credit", append: "" },
  //     { id: "acknowledged_user", append: "" },
  //     { id: "acknowledged_at", append: "" },
  //     { id: "date", append: "" },
  //   ];
  //   const custom = getCustomId(columns, columnFilters, appendData);
  //   const filter = getFilterPayload(custom?.columns, custom?.columnFilters);
  //   const fields = getFields(custom?.columns);

  //   api_filter(model, filter, fields)
  //     .then(res => {
  //       if (res.success) {
  //         console.log(res.data);
  //         const head_content = getHeaders(columns);
  //         const body_content = getBodyContent(res.data, fields);
  //         const csv_content = getCsvContent(head_content, body_content, ["SALES_REPORT"]);
  //         setFilename(
  //           "SALES_REPORT" + "_" + "WareHouse" + "_" + new Date().toLocaleDateString() + ".csv"
  //         );
  //         setCsv(csv_content);
  //         setHead(head_content);
  //         setBody(body_content);
  //         setFoot([]);
  //       } else {
  //         showErrorToast({ title: "Error", message: res.message });
  //       }
  //     })
  //     .catch(e => {
  //       showErrorToast({ title: "Error", message: e.message });
  //     });
  // };

  const printFilter = async (forCsv = true) => {
    const model = "CutOff";
    const appendData = [
      { id: "name", append: "counter__", replace_id: "counter_name" },
      { id: "cash", append: "" },
      { id: "card", append: "" },
      { id: "gift", append: "" },
      { id: "credit", append: "" },
      { id: "acknowledged_user", append: "" },
      { id: "acknowledged_at", append: "" },
      { id: "date", append: "" },
    ];
  
    const custom = getCustomId(columns, columnFilters, appendData);
    const filterPayload = getFilterPayload(custom?.columns, custom?.columnFilters);
    const fields = getFields(custom?.columns);
  
    try {
      const res = await api_filter(model, filterPayload, fields,"CutOffSerializer");
      if (res.success) {
        if (forCsv) {
          // **CSV Export**
          const head_content = getHeaders(columns);
          const body_content = getBodyContent(res.data, fields);
          const csv_content = getCsvContent(head_content, body_content, ["SALES_REPORT"]);
          
          setFilename(`SALES_REPORT_WareHouse_${new Date().toLocaleDateString()}.csv`);
          setCsv(csv_content);
          setHead(head_content);
          setBody(body_content);
          setFoot([]);
        } else {
          // **Table Filtering**
          return { data: res.data };
        }
      } else {
        showErrorToast({ title: "Error", message: res.message });
        return { data: [] };
      }
    } catch (e) {
      showErrorToast({ title: "Error", message: e.message });
      return { data: [] };
    }
  };
  

  const csvRef = useRef();
  useEffect(() => {
    if (csv.length && isCsv) {
      csvRef.current.link.click();
      setCsv([]);
      setIsCsv(false);
    }
  }, [csv]);

  return (
    <>
      <CSVLink
        style={{ display: "none" }}
        asyncOnClick={true}
        data={csv}
        filename={filename}
        ref={csvRef}
      ></CSVLink>
      {isMobileScreen ? (
        <>
          <DatePickerInput
            p={5}
            onChange={setDate}
            label="Date"
            defaultValue={date}
            placeholder="Please Select Date"
            valueFormat="DD-MM-YYYY"
          />
        </>
      ) : (
        <Container fluid>
          <Box p={25}>
            <Flex justify={"space-between"} align="end">
              <Box>
                <Text size={"lg"} fw={600} mb={10}>
                  Cut-off Sales Report
                </Text>
                <AppBreadcrumb />
              </Box>
              <Flex gap={10} align={"flex-end"}>
                <Button
                  onClick={() => {
                    setIsCsv(true);
                    printFilter();
                  }}
                  leftIcon={<IconDownload />}
                >
                  CSV
                </Button>
                {/* <Button
                  leftIcon={<IconPrinter />}
                  onClick={() => {
                    print(true);
                  }}
                >
                  Print
                </Button> */}
                <Button
                  leftIcon={<IconPrinter />}
                  onClick={() => {
                    printFilter();
                  }}
                >
                  Print
                </Button>
                <DatePickerInput
                  w={200}
                  onChange={setDate}
                  label="Date"
                  defaultValue={date}
                  placeholder="Please Select Date"
                  valueFormat="DD-MM-YYYY"
                />
              </Flex>
            </Flex>
          </Box>
        </Container>
      )}

      <Container fluid mt={10} mb={30}>
        <Box px={isMobileScreen ? 5 : 25} sx={{ borderRadius: 2 }}>
          <Box className="datatable-wrapper">
            <MantineReactTable
              manualFiltering={true} //turn off client-side filtering
              onColumnFiltersChange={setColumnFilters} //hoist internal columnFilters state to your state
              state={columnFilters} //pass in your own managed columnFilters state
              mantineTableProps={{ className: "datatable" }}
              enableRowActions
              positionActionsColumn="last"
              renderTopToolbarCustomActions={({ row }) => (
                <Box px={isMobileScreen ? 5 : 24} py={10}>
                  <Text
                    fw={600}
                    tt="uppercase"
                    size={"sm"}
                    sx={theme => ({
                      letterSpacing: 1,
                      color: theme.colors.brand[7],
                    })}
                  >
                    List
                  </Text>
                </Box>
              )}
              renderRowActions={({ row }) => {
                return (
                  <Flex>
                    <Tooltip label="Acknowledge" color={"green"}>
                      <ActionIcon
                        disabled={row.original.acknowledged_user}
                        sx={theme => ({ color: theme.colors.green[7] })}
                        onClick={() => {
                          openAcceptStockConfirmation(row.original.id);
                        }}
                        mr={4}
                      >
                        <IconSquareRoundedCheck style={{ width: 22 }} />
                      </ActionIcon>
                    </Tooltip>
                  </Flex>
                );
              }}
              initialState={{ density: "xs" }}
              //state={{ isLoading: data.isLoading }}
              columns={columns}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableColumnActions={false}
              data={data.data?.data?.sort((a, b) => a?.counter_name?.localeCompare(b?.counter_name)) || []}
              enableStickyHeader
              enableGlobalFilter={false}
            />
          </Box>
        </Box>
      </Container>
      <div style={{ display: "none" }}>
        <PrintModal
          title="Cut-off Sales Report"
          head={head}
          body={body}
          foot={foot}
          ref={componentRef}
        />
      </div>

      {isMobileScreen ? (
        <>
          <FloatingMenu
            m={5}
            left
            size={50}
            onClick={() => {
              setIsCsv(true);
              printFilter();
            }}
          >
            <IconDownload color="white" />
          </FloatingMenu>
          <FloatingMenu
            m={5}
            right
            size={50}
            onClick={() => {
              printFilter();
            }}
          >
            <IconPrinter color="white" />
          </FloatingMenu>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
